import apiClient from "./apiClient";

export class BaseService<T, TCreate = T> {
  protected url: string;

  constructor(endpoint: string) {
    this.url = endpoint;
  }

  async getAll(
    queryParams: Record<string, string | number> = {},
    signal?: AbortSignal,
  ): Promise<T[]> {
    return (await apiClient.get<T[]>(this.url, {
      params: queryParams,
      signal,
    })) as unknown as T[];
  }

  async getById(id: number | string, signal?: AbortSignal): Promise<T> {
    return (await apiClient.get<T>(`${this.url}/${id}`, {
      signal,
    })) as unknown as T;
  }

async create(data: TCreate, signal?: AbortSignal): Promise<T> {
    return (await apiClient.post<T>(this.url, data, {
      signal,
    })) as unknown as T;
  }

async update(
    id: number | string,
    data: T,
    signal?: AbortSignal,
  ): Promise<boolean> {
    await apiClient.put(`${this.url}/${id}`, data, { signal });
    return true;
  }

  async delete(id: number | string, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${this.url}/${id}`, { signal });
  }

  async getByPatientId(
    patientId: number | string,
    signal?: AbortSignal,
  ): Promise<T[]> {
    return (await apiClient.get<T[]>(`${this.url}/patient/${patientId}`, {
      signal,
    })) as unknown as T[];
  }
  //για Post
async search(
    searchParams: Record<string, any>,
    signal?: AbortSignal,
  ): Promise<T[]> {
    return (await apiClient.post<T[]>(`${this.url}/search`, searchParams, {
      signal,
    })) as unknown as T[];
  }
}
